<section class="grid min-h-screen place-items-center bg-t-bg p-4">
  <div class="ic-surface w-full max-w-md p-8 text-center">
    <span class="material-icons text-[40px] leading-none text-t-accent-ink" aria-hidden="true">build</span>
    <h1 class="ic-page-title mt-3">În mentenanță.</h1>
    <p class="mt-2 text-t-base text-t-ink-2">Aplicația este în curs de actualizare.</p>
  </div>
</section>
